/**
 * Version information for dungeo
 * Auto-generated by build.sh - DO NOT EDIT
 */
export const STORY_VERSION = '0.9.111';
export const BUILD_DATE = '2026-04-14T20:42:05Z';
export const ENGINE_VERSION = '0.9.111';
export const VERSION_INFO = { version: STORY_VERSION, buildDate: BUILD_DATE, engineVersion: ENGINE_VERSION } as const;
